module.exports = __webpack_public_path__ + "static/media/oi.feece3bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/OI Modal/oi.png
// module id = 865
// module chunks = 0